
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap-blog.xml",
      function () {
        return require("private-next-pages/sitemap-blog.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap-blog.xml"])
      });
    }
  